import Vue from 'vue'
import Router from 'vue-router'
// import commonJs from '@/assets/js/common'
import login from '@/components/pages/login/login'
import logout from '@/components/pages/login/logout'
import impersonate from '@/components/pages/login/impersonate'
import noPermission from '@/components/pages/login/noPermission'
import index from '@/components/pages/myIndex/index'
// 项目页面
import asm from '@/components/pages/gileadSales/asm'
import rsd from '@/components/pages/gileadSales/rsd'
import nsd from '@/components/pages/gileadSales/nsd'
import salesReadOnly from '@/components/pages/gileadSales/nsdReadOnly'
import report from '@/components/pages/gileadSales/report'
import mkt from '@/components/pages/gileadSales/mkt'
import mktReport from '@/components/pages/gileadSales/mktReport'
import mktSales from '@/components/pages/gileadSales/mktSales'
import LEManagement from '@/components/pages/gileadSales/LEManagement'
import UserManagement from '@/components/pages/admin/UserManagement'
import bazaar from '@/components/pages/bazaar/bazaar'
import RoleSetUp from '@/components/pages/admin/RoleSetUp'
import notice from '@/components/pages/notice/notice'
import startData from '@/components/pages/startData/startData'

Vue.use(Router)
let router = new Router({
// export default new Router({
//   mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/logout',
      name: 'logout',
      component: logout
    },
    {
      path: '/noPermission',
      name: 'noPermission',
      component: noPermission
    },
    {
      path: '/impersonate',
      name: 'impersonate',
      component: impersonate
    },
    {
      path: '/index',
      name: 'index',
      // redirect: '/asm',
      component: index,
      children: [
        {
          path: '/asm',
          name: 'ASM',
          component: asm
        },
        {
          path: '/rsd',
          name: 'RSD',
          component: rsd
        },
        {
          path: '/nsd',
          name: 'NSD',
          component: nsd
        },
        {
          path: '/salesReadOnly',
          name: 'SalesReadOnly',
          component: salesReadOnly
        },
        {
          path: '/report',
          name: 'Report',
          component: report
        },
        {
          path: '/mkt',
          name: 'mkt',
          component: mkt,
          children: [
            {
              path: '/mktSales',
              name: 'mktSales',
              component: mktSales
            }
          ]
        },
        {
          path: '/mktReport',
          name: 'Forecast历史',
          component: mktReport,
          children: [
            {
              path: '/mktSales',
              name: 'mktSales',
              component: mktSales
            }
          ]
        },
        {
          path: '/LEManagement',
          name: 'LEManagement',
          component: LEManagement
        },
        {
          path: '/userManagement',
          name: 'UserManagement',
          component: UserManagement
        },
        {
          path: '/bazaar',
          name: 'bazaar',
          component: bazaar
        },
        {
          path: '/roleSetUp',
          name: 'RoleSetUp',
          component: RoleSetUp
        },
        {
          path: '/notice',
          name: 'notice',
          component: notice
        },
        {
          path: '/startData',
          name: 'startData',
          component: startData
        }
      ]
    }
  ],
  linkActiveClass: 'is-active'
})
// router.beforeEach((to, from, next) => {
//   if (to.name === 'ASM') {
//     commonJs.topName = 'ASM'
//     next()
//   } else if (to.name === 'RSD') {
//     commonJs.topName = 'RSD'
//     next()
//   } else if (to.name === 'NSD') {
//     commonJs.topName = 'NSD'
//     next()
//   } else if (to.name === 'Report') {
//     commonJs.topName = 'Report'
//     next()
//   } else if (to.name === 'mkt' || to.name === 'mktSales') {
//     commonJs.topName = 'Forecast'
//     next()
//   } else if (to.name === 'UserManagement') {
//     commonJs.topName = window.localStorage.getItem('language') === 'zh-CN' ? '用户管理' : 'User Management'
//     next()
//   } else if (to.name === 'bazaar') {
//     commonJs.topName = window.localStorage.getItem('language') === 'zh-CN' ? '市场部类别管理' : 'Market Segmentation'
//     next()
//   } else if (to.name === 'RoleSetUp') {
//     commonJs.topName = window.localStorage.getItem('language') === 'zh-CN' ? '角色管理' : 'Role Management'
//     next()
//   } else if (to.name === 'notice') {
//     commonJs.topName = window.localStorage.getItem('language') === 'zh-CN' ? '公告管理' : 'Announcemenet Management'
//     next()
//   } else if (to.name === 'startData') {
//     commonJs.topName = window.localStorage.getItem('language') === 'zh-CN' ? '版本启动管理' : 'Cycle Management'
//     next()
//   } else {
//     commonJs.topName = ''
//     next()
//   }
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js